<template>
    <div class="html-rich-editor">
        <div class="editor-switch mb-2">
            <button
                type="button"
                class="btn btn-sm me-2"
                :class="mode === 'rich' ? 'btn-primary' : 'btn-outline-primary'"
                @click="switchToRich"
            >
                <i class="bi bi-pencil me-1"></i>
                Edytor
            </button>

            <button
                type="button"
                class="btn btn-sm"
                :class="mode === 'html' ? 'btn-dark' : 'btn-outline-dark'"
                @click="switchToHtml"
            >
                <i class="bi bi-code-slash me-1"></i>
                HTML
            </button>
        </div>

        <!-- EDYTOR -->
        <div v-if="mode === 'rich'">
            <RichTextEditorComponent
                :id="id"
                :label="label"
                :modelName="modelName"
                :modelText="localValue"
                :hidden="false"
                @updateModel="onRichTextUpdate"
            />
        </div>

        <!-- CZYSTY HTML -->
        <div v-else>
            <label class="form-label">
                Kod HTML wiadomości:
            </label>

            <textarea
                v-model="localValue"
                class="form-control html-textarea"
                spellcheck="false"
                @input="emitValue"
            ></textarea>

            <div class="form-text">
                Tutaj możesz wpisać dowolny HTML wiadomości.
            </div>
        </div>
    </div>
</template>

<script>
import RichTextEditorComponent from "@/Pages/Admin/parts/RichTextEditorComponent.vue";

export default {
    name: "HtmlOrRichTextEditor",

    components: {
        RichTextEditorComponent
    },

    props: {
        id: {
            type: String,
            default: "htmlRichEditor"
        },

        label: {
            type: String,
            default: "Treść wiadomości"
        },

        modelName: {
            type: String,
            default: "description"
        },

        modelValue: {
            type: String,
            default: ""
        }
    },

    emits: ["update:modelValue"],

    data() {
        return {
            mode: "html",
            localValue: this.modelValue || ""
        };
    },

    watch: {
        modelValue: {
            immediate: true,
            handler(value) {
                this.localValue = value || "";
            }
        }
    },

    methods: {
        emitValue() {
            this.$emit("update:modelValue", this.localValue);
        },

        onRichTextUpdate(value) {
            this.localValue = value?.value ?? value ?? "";

            this.$emit("update:modelValue", this.localValue);
        },

        switchToHtml() {
            this.mode = "html";

            // Ponownie pobierz aktualną wartość
            this.localValue = this.modelValue || "";
        },

        switchToRich() {
            this.mode = "rich";

            // Zachowaj aktualną wartość
            this.$nextTick(() => {
                this.localValue = this.modelValue || this.localValue || "";
            });
        }
    }
};
</script>

<style scoped>
.html-textarea {
    min-height: 450px;
    width: 100%;
    font-family: monospace;
    font-size: 13px;
    line-height: 1.5;
    resize: vertical;
}

.editor-switch {
    display: flex;
    align-items: center;
}
</style>